// import styles from './App.module.css'
import { Suspense } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import zhCN from 'antd/locale/zh_CN'
import { ConfigProvider } from 'antd'
import _routers, { Layout } from '@/routers'
import { configure } from 'mobx'
configure({
  enforceActions: 'never',
  useProxies: 'never',
})

function App() {
  const renderRoutes = (routes) => {
    return routes.map((route, index) => (
      <Route
        key={index}
        path={route.path}
        element={<Layout hideHeader={route.hideHeader} hideFooter={route.hideHeader} />}
      >
        <Route index element={route.element}>
          {route.children && renderRoutes(route.children)}
        </Route>
      </Route>
    ))
  }

  return (
    <ConfigProvider
      locale={zhCN}
      theme={{
        components: {
          Layout: {
            headerBg: '#fff',
            footerBg: '#1f2937',
          },
        },
      }}
    >
      <Router>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>{renderRoutes(_routers)}</Routes>
        </Suspense>
      </Router>
    </ConfigProvider>
  )
}

export default App
